
import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  Center,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  VStack,
  Grid,
  GridItem,
  FormControl,
  FormLabel, ModalFooter, Text,
  HStack,
  Tooltip,
  IconButton
} from "@chakra-ui/react";
import {
  addJobSkillsAsync,
  deleteJobSkillsAsync,
  fetchJobSkillsAsync,
  selectJobSkills,
  updateJobSkillsAsync,
} from "../../../JobPostingSlice/JobSkillsList/JobSkillsSlice";
import { useDispatch, useSelector } from "react-redux";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";

function ReqdSkills() {
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const dispatch = useDispatch();
  const jobSkills = useSelector(selectJobSkills);

  useEffect(() => {
    dispatch(fetchJobSkillsAsync());
  }, [dispatch]);

  const [newJobSkill, setNewJobSkill] = useState("");
  const [newJobStatus, setNewJobStatus] = useState("");
  const [error, setError] = useState(null);
  const [editJobSkill, setEditJobSkill] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editJobStatus, setEditJobStatus] = useState("");
  const [editableJobSkill, setEditableJobSkill] = useState(null);
  const [deletingSkill, setDeletingSkill] = useState(null);

  const handleDelete = async (uuid) => {
    await dispatch(deleteJobSkillsAsync(uuid));
    dispatch(fetchJobSkillsAsync());
    onClose2();
  };

  const openDeleteModal = (job) => {
    setDeletingSkill(job);
    onOpen2();
  };

  const handleSave = async () => {
    const jobSkill = {
      title: newJobSkill,
      status: newJobStatus,
    };

    try {
      await dispatch(addJobSkillsAsync(jobSkill));
      dispatch(fetchJobSkillsAsync());
      setNewJobSkill("");
      setNewJobStatus("");
      onClose1();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleEdit = (jobSkill) => {
    setEditableJobSkill(jobSkill);
    setEditJobSkill(jobSkill.title);
    setEditJobStatus(jobSkill.status);
    setIsEditModalOpen(true);
  };

  const handleUpdate = async () => {
    if (editJobSkill.trim()) {
      try {
        await dispatch(
          updateJobSkillsAsync({
            uuid: editableJobSkill.uuid,
            jobSkillData: {
              title: editJobSkill,
              status: editJobStatus,
            },
          })
        );

        await dispatch(fetchJobSkillsAsync());
        setEditableJobSkill(null);
        setEditJobSkill("");
        setEditJobStatus("");
        setIsEditModalOpen(false);
      } catch (err) {
        setError(err.message);
      }
    }
  };

  return (
    <div className="h-screen bg-adminbg p-4 contentAdmin" style={{ fontFamily: "Inter, sans-serif" }}>
      <div className="">
        <div className="w-full my-5 bg-white rounded-md">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              Skills List
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Button
                colorScheme="blue"
                fontSize={"medium"}
                alignContent={"center"}
                onClick={onOpen1}
              >
                Add<i className="fa-solid fa-plus px-2"></i>
              </Button>

              <Modal isOpen={isOpen1} onClose={onClose1} size="4xl">
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Add Skills
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <ModalBody py={6}>
                    <VStack spacing={6}>
                      <Grid templateColumns="repeat(2, 1fr)" gap={4} width="100%">
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>Job Skill</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter Job Skill"
                              value={newJobSkill}
                              onChange={(e) => setNewJobSkill(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>Job Status</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter Job Status"
                              value={newJobStatus}
                              onChange={(e) => setNewJobStatus(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                      </Grid>
                      {error && <Text color="red.500">{error}</Text>}
                    </VStack>
                  </ModalBody>
                  <ModalFooter bg="gray.50" borderBottomRadius="md">
                    <Button colorScheme="blue" mr={3} onClick={handleSave}>
                      Save
                    </Button>
                    <Button onClick={onClose1}>Cancel</Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>

              <Modal isOpen={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} size="4xl">
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Edit Skills
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <ModalBody py={6}>
                    <VStack spacing={6}>
                      <Grid templateColumns="repeat(2, 1fr)" gap={4} width="100%">
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>Job Skill</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter job skill"
                              value={editJobSkill}
                              onChange={(e) => setEditJobSkill(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>Job Status</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter job status"
                              value={editJobStatus}
                              onChange={(e) => setEditJobStatus(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                      </Grid>
                      {error && <Text color="red.500">{error}</Text>}
                    </VStack>
                  </ModalBody>
                  <ModalFooter bg="gray.50" borderBottomRadius="md">
                    <Button colorScheme="blue" mr={3} onClick={handleUpdate}>
                      Update
                    </Button>
                    <Button onClick={() => setIsEditModalOpen(false)}>Cancel</Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>

              <Modal isOpen={isOpen2} onClose={onClose2}>
                <ModalOverlay />
                <ModalContent maxW="2xl" borderradius="lg" boxShadow="lg">
                  <ModalHeader fontSize="lg" fontWeight="bold" textAlign="center">
                    Confirm Deletion
                  </ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                    <Text fontSize="md" textAlign="center">
                      Are you sure you want to delete{" "}
                      <Text as="span" fontWeight="semibold" color="red.500">
                        "{deletingSkill?.title}"
                      </Text>
                      ?
                    </Text>
                  </ModalBody>
                  <ModalFooter display="flex" gap="2" justifyContent="center">
                    <Button
                      colorScheme="red"
                      w="40"
                      onClick={() => handleDelete(deletingSkill.uuid)}
                    >
                      Delete
                    </Button>
                    <Button variant="outline" colorScheme="red" w="40" onClick={onClose2}>
                      Cancel
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            </div>
          </div>

          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="w-1/4">uuid</Th>
                  <Th className="w-1/4">Title</Th>
                  <Th className="w-1/4">Status</Th>
                  <Th className="w-1/4">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {[...jobSkills]
                  .sort((a, b) => a.uuid - b.uuid)
                  .map((job, index) => (
                    <Tr key={job.uuid}>
                      <Td>{index + 1}</Td>
                      <Td>{job.title}</Td>
                      <Td textColor={"green"}>{job.status}</Td>
                      <Td>
                        <HStack spacing={2}>
                          <Tooltip label="Edit Skill" placement="top">
                            <IconButton
                              icon={<EditIcon />}
                              colorScheme="blue"

                              size="sm"
                              onClick={() => handleEdit(job)}
                              aria-label="Edit industry"
                            />
                          </Tooltip>
                          <Tooltip label="Delete Skill" placement="top">
                            <IconButton
                              icon={<DeleteIcon />}
                              colorScheme="red"

                              size="sm"
                              onClick={() => openDeleteModal(job)}
                              aria-label="Delete industry"
                            />
                          </Tooltip>
                        </HStack>
                      </Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default ReqdSkills;